import { faAngleDoubleRight } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Tooltip } from '@ui';
import useMediaQuery from 'hooks/useMediaQuery';
import { DatePicker } from '~/components/Form/next/FormDatePicker';
import { Button } from '../styledComponents/Button';

interface Props {
    handleWeekJump: (data: {}) => void;
    placement?: any;
}

export const WeekJumpTooltip = ({ handleWeekJump, placement: popperPlacement }: Props) => {
    const isMobile = useMediaQuery('(max-width: 650px)');

    return (
        <Tooltip
            tooltip={
                <DatePicker
                    value={null}
                    inline
                    onChange={(date) => handleWeekJump({ weekToJump: date })}
                    popperPlacement={popperPlacement}
                    borderless
                />
            }
            trigger="click"
        >
            <Button variant="light" className="tw-h-full tw-w-full tw-rounded-none">
                {isMobile ? <FontAwesomeIcon icon={faAngleDoubleRight} /> : 'Zu Woche springen'}
            </Button>
        </Tooltip>
    );
};
